import { useTranslation } from "react-i18next";
import { LocalizedLink } from "@/i18n/language";
import { img } from "@/lib/images";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-primary-700 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="mb-4 flex items-center">
            <div className="h-12 md:h-20 w-[200px] md:w-[320px] flex items-center justify-start">
              <img
                src={img("balivwtour/brand/logo-balivwtour-01.png")}
                alt="BaliVWTour Logo"
                title="BaliVWTour"
                className="h-full w-auto max-w-full object-contain object-left"
              />
            </div>
          </div>
          <p className="text-sm text-background-200 leading-relaxed">
            {t("footer_about")}
          </p>
          <div className="flex gap-3 mt-5">
            <a href="https://www.facebook.com/balivwtour" target="_blank" rel="noopener noreferrer" aria-label="BaliVWTour auf Facebook" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1877F2] border border-white/30 hover:opacity-90 cursor-pointer transition-opacity">
              <i className="ri-facebook-fill"></i>
            </a>
            <a href="https://wa.me/6281246218000" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-[#25D366] border border-white/30 hover:opacity-90 cursor-pointer transition-opacity">
              <i className="ri-whatsapp-fill"></i>
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-lg mb-4 text-accent-300">{t("footer_contact")}</h4>
          <ul className="space-y-3 text-sm text-background-200">
            <li className="flex gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-accent-400 flex-shrink-0"><i className="ri-map-pin-line"></i></span>
              <span>{t("footer_address")}</span>
            </li>
            <li className="flex gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-accent-400 flex-shrink-0"><i className="ri-phone-line"></i></span>
              <a href="tel:+623618956561" className="hover:text-accent-300 cursor-pointer transition-colors">{t("footer_phone")}</a>
            </li>
            <li className="flex gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-[#25D366] flex-shrink-0"><i className="ri-whatsapp-fill"></i></span>
              <a href="https://wa.me/6281246218000" target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 cursor-pointer transition-colors">WhatsApp: +62 81 246 21 8000</a>
            </li>
            <li className="flex gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-accent-400 flex-shrink-0"><i className="ri-mail-line"></i></span>
              <a href="mailto:office@balivwtour.com" className="hover:text-accent-300 cursor-pointer transition-colors">E-Mail: office@balivwtour.com</a>
            </li>
            <li className="flex gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-accent-400 flex-shrink-0"><i className="ri-global-line"></i></span>
              <a href="https://www.balivwtour.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 cursor-pointer transition-colors">{t("footer_website")}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-lg mb-4 text-accent-300">{t("footer_partners")}</h4>
          <ul className="space-y-4 text-sm text-background-200">
            <li>
              <a
                href="http://www.balichakratours.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-flex items-center gap-1.5 font-medium text-background-50 hover:text-accent-300 cursor-pointer transition-colors"
              >
                {t("footer_partner_1_title")}
                <i className="ri-arrow-right-up-line text-xs opacity-60 group-hover:opacity-100"></i>
              </a>
              <p className="mt-1 text-xs leading-relaxed text-background-300">{t("footer_partner_1_desc")}</p>
            </li>
            <li>
              <a
                href="https://www.villakompiangbali.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-flex items-center gap-1.5 font-medium text-background-50 hover:text-accent-300 cursor-pointer transition-colors"
              >
                {t("footer_partner_2_title")}
                <i className="ri-arrow-right-up-line text-xs opacity-60 group-hover:opacity-100"></i>
              </a>
              <p className="mt-1 text-xs leading-relaxed text-background-300">{t("footer_partner_2_desc")}</p>
            </li>
            <li>
              <a
                href="https://ralfs-vw-teile.de/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="group inline-flex items-center gap-1.5 font-medium text-background-50 hover:text-accent-300 cursor-pointer transition-colors"
              >
                {t("footer_partner_3_title")}
                <i className="ri-arrow-right-up-line text-xs opacity-60 group-hover:opacity-100"></i>
              </a>
              <p className="mt-1 text-xs leading-relaxed text-background-300">{t("footer_partner_3_desc")}</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-500/40">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <div>© 2004-2026 balivwtour.com. {t("footer_rights")}</div>
          <div className="flex gap-4">
            <LocalizedLink to="/impressum" className="hover:text-accent-300 cursor-pointer">{t("footer_terms")}</LocalizedLink>
            <LocalizedLink to="/privacy" className="hover:text-accent-300 cursor-pointer">{t("footer_privacy")}</LocalizedLink>
            <LocalizedLink to="/backstage" className="hover:text-accent-300 cursor-pointer opacity-40 hover:opacity-100 transition-opacity">Backstage</LocalizedLink>
          </div>
        </div>
      </div>
    </footer>
  );
}